import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { FilterProvider } from "@/context/FilterContext";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import TrustStrip from "@/components/TrustStrip";
import CategoriesGrid from "@/components/CategoriesGrid";
import PopularProducts from "@/components/PopularProducts";
import RecommendedCarousel from "@/components/RecommendedCarousel";
import Manifesto from "@/components/Manifesto";
import Products from "@/components/Products";
import Spotlight from "@/components/Spotlight";
import Footer from "@/components/Footer";
import BigMarquee from "@/components/BigMarquee";
import CartDrawer from "@/components/CartDrawer";
import ProductPage from "@/components/ProductPage";
import ThanksPage from "@/components/ThanksPage";

const Home = () => {
  const location = useLocation();
  useEffect(() => {
    if (!location.hash) return;
    const timer = setTimeout(() => {
      if (window.__lenis) {
        window.__lenis.scrollTo(location.hash, { offset: -64 });
      } else {
        document.querySelector(location.hash)?.scrollIntoView({ behavior: "smooth" });
      }
    }, 400);
    return () => clearTimeout(timer);
  }, [location.hash]);

  return (
    <main>
      <Hero />
      <Marquee />
      <TrustStrip />
      <PopularProducts />
      <RecommendedCarousel />
      <CategoriesGrid />
      <Products />
      <Spotlight />
      <Manifesto />
      <BigMarquee />
    </main>
  );
};

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (window.matchMedia("(pointer: coarse)").matches) return;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <MotionConfig reducedMotion="user">
      <CartProvider>
        <FilterProvider>
          <BrowserRouter>
            <div className="App bg-bone text-ink">
              <div className="grain-overlay hidden md:block" aria-hidden="true" />
              <Nav />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/product/:productId" element={<ProductPage />} />
                <Route path="/thanks" element={<ThanksPage />} />
              </Routes>
              <Footer />
              <CartDrawer />
              <Toaster position="bottom-right" />
            </div>
          </BrowserRouter>
        </FilterProvider>
      </CartProvider>
    </MotionConfig>
  );
}

export default App;
